import {Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {TagChip} from 'presentation/components';
import {ProtocolStatusEnum} from 'presentation/pages/private/consult-protocols/constants';
import {ProtocolStatusProps} from './types';

const {protocolLabel, lastUpdateLabel} = translations['pt-br'].privateFlow.consultProtocols;

export function ProtocolStatus({protocol, lastUpdate}: ProtocolStatusProps) {
	const isStatusCompleted = protocol.statusDescricao === ProtocolStatusEnum.COMPLETED;

	return (
		<Stack gap={1.5}>
			<Stack>
				<Typography variant="body1" color="text.primary">
					{protocolLabel}
					<b>{protocol?.registro}</b>
				</Typography>
				<Typography variant="body2" color="text.secondary">
					{protocol?.tipoProtocolo}
				</Typography>
			</Stack>
			{protocol?.statusDescricao ? (
				<TagChip
					label={protocol.statusDescricao}
					color={isStatusCompleted ? 'success' : 'primary'}
					sx={{
						alignSelf: 'flex-start',
					}}
				/>
			) : null}

			{lastUpdate ? (
				<Typography variant="body2" color="text.primary">
					{lastUpdateLabel} {lastUpdate}
				</Typography>
			) : null}
		</Stack>
	);
}
